exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true,\"alias\":{\"../img\":\"../static/img\"}}!../assets/css/snow.css"), "");

// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ChristmasThemeCSS.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a91359c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChristmasThemeCSS.vue
// module id = 1333
// module chunks = 0